import { Schema } from 'yup';

import { Carriers } from '../../../../../common/constants/carriers';
import { LetterFormData } from './hooks/useLetterForm';

export enum LetterTypes {
  otaf = 'otaf',
  otafSamePrice = 'otafSamePrice',
  decline = 'decline',
  withdrawal = 'withdrawal',
  substandard = 'substandard',
  reinstatementApproval = 'reinstatementApproval',
  reinstatementDecline = 'reinstatementDecline',
  reinstatementWithdrawal = 'reinstatementWithdrawal',
}

export enum Fields {
  medicalFacilityOrProvider = 'medicalFacilityOrProvider',
  ratableHistory = 'ratableHistory',
  declinableHistory = 'declinableHistory',
  height = 'height',
  weight = 'weight',
  dateMeasurementTaken = 'dateMeasurementTaken',
  applicableQuestionnaire = 'applicableQuestionnaire',
  customContent = 'customContent',
  riskGroup = 'riskGroup',
  riskDetail = 'riskDetail',
  risk = 'risk',
  reference = 'reference',
  diagnosis = 'diagnosis',
  information = 'information',
  piiDataType = 'piiDataType',
}

export enum Sources {
  appInfoDisclosure = 'appInfoDisclosure',
  aps = 'aps',
  buildDisclosedOnApp = 'buildDisclosedOnApp',
  buildInAps = 'buildInAps',
  criminalHistory = 'criminalHistory',
  eti = 'eti',
  financial = 'financial',
  labPiQture = 'labPiQture',
  rxEti = 'rxEti',
  mibAppEti = 'mibAppEti',
  mibAps = 'mibAps',
  mibRxOrMedClaimsMilliman = 'mibRxOrMedClaimsMilliman',
  medClaimsAps = 'medClaimsAps',
  mibInsuranceLabs = 'mibInsuranceLabs',
  mibLabPiQture = 'mibLabPiQture',
  mvr = 'mvr',
  rxOrMedClaimsMilliman = 'rxOrMedClaimsMilliman',
  rxOrMedClaimsExamOne = 'rxOrMedClaimsExamOne',
  trl = 'trl',
  custom = 'custom',
  medicalCondition = 'medicalCondition',
  lackOfAps = 'lackOfAps',
  lackOfInformation = 'lackOfInformation',
  miscellaneous = 'miscellaneous',
  pii = 'pii',
  specialCharacter = 'specialCharacter',
  unresolvedMib = 'unresolvedMib',
  foreignLanguage = 'foreignLanguage',
}

export enum FieldTypes {
  text = 'text',
  date = 'date',
  textarea = 'textarea',
}

export interface Field {
  name: string;
  label: string;
  type: FieldTypes;
  schema: Schema;
  placeholder?: string;
  defaultValue?: string;
}

export interface Data {
  phone: string;
  email: string;
  date: string;
  carrier: Carriers;
  fullName: string;
  letter: LetterFormData;
  source: Sources | null;
  letterType: LetterTypes;
  policyNumber: string;
  riders: string[];
  isJuvenile?: boolean;
  insuredName?: string;
}

export interface Option<T> {
  label: string;
  value: T;
}
